module.exports = __webpack_public_path__ + "static/media/link-new-tab.a1ce9aa9.svg";